import {
    Module,
    VuexModule,
    Mutation,
    Action,
    getModule,
} from 'vuex-module-decorators';
import store from '~common-store';

import { NotificationOptions } from '~node_modules/vue-notification';

@Module({ dynamic: true, store, name: 'notifications', namespaced: true })
class Notifications extends VuexModule {
    notificationsArray: NotificationOptions[] = [];

    @Mutation
    PUSH_NOTIFICATION(newNotification: NotificationOptions) {
        this.notificationsArray.push(newNotification);
    }

    @Action({ commit: 'PUSH_NOTIFICATION' })
    pushNotification(newNotification: NotificationOptions) {
        return newNotification;
    }

    @Mutation
    SHIFT_NOTIFICATION() {
        this.notificationsArray.shift();
    }

    @Action({ commit: 'SHIFT_NOTIFICATION' })
    async shiftNotification() {
        return;
    }
}

export const NotificationsModule = getModule(Notifications);
